import {
  List,
  Datagrid,
  TextField,
  EmailField,
  FunctionField,
  EditButton,
  BulkDeleteButton,
  usePermissions,
} from "react-admin";

import { Box, Typography } from "@mui/material";



// ✅ List View

export const GroupRoleList = (props) => (
  <>
    <List title="Group Roles" {...props}>
       <Box sx={{ pt: 5, pb: 5 }}>
        <Typography variant="h4" fontWeight={600} align="left">
          Group Roles
        </Typography>
      </Box>
      <Datagrid rowClick="show" bulkActionButtons={<BulkDeleteButton />}>
        <TextField source="id" />
        <TextField source="group_name" label="Group" />
        <TextField source="roles" label="Roles" />
        <EditButton />
      </Datagrid>
    </List>
  </>
);

